import { UserProvider } from './../interfaces/user-provider';
import { ProvidersService } from './../services/providers.service';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountModificationComponent } from '../account-modification/account-modification.component';
import { AccountModificationPwdComponent } from '../account-modification-pwd/account-modification-pwd.component';
import { ToastrService } from 'ngx-toastr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AuthService } from '../services/auth.service';
import { AccountDeletionComponent } from '../account-deletion/account-deletion.component';

@Component({
    selector: 'app-account-provider',
    templateUrl: './account-provider.component.html',
    styleUrls: ['./account-provider.component.scss']
})
export class AccountProviderComponent implements OnInit {

    @BlockUI() blockUI: NgBlockUI;

    public url: any;
    id_user: string = "";
    id_org_internal: string = "";

    provider: UserProvider = {
        id: "",
        firstName: "",
        lastName: "",
        fullName: "",
        email: "",
        isActive: false,
        lastConnect: "",
        providerName: "",
        description: "",
        logo: "",
        phone: "",
        geolocation: "",
        adressCity: "",
        adressCountry: "",
        adressPostalCode: "",
        adressStreet: "",
        adressState: "",
        nbProductsTotal: 0,
        nbOrderRefused: 0,
        nbProductsSold: 0
    };

    constructor(
        private accountModalService: NgbModal,
        private toastrService: ToastrService,
        private providersService: ProvidersService,
        private authService: AuthService,
    ) {
        authService.getLoggedInName.subscribe((token) => {
            this.getProviderDetailById()
        });
    }

    ngOnInit(): void {
        this.getProviderDetailById();
    }

    getProviderDetailById() {
        this.blockUI.start('Loading');

        const token = localStorage.getItem('token');

        this.authService.decodeJWT(token).subscribe(
            (res: any) => {
                if (res.success) {
                    this.id_user = res.data.id_user;
                    this.id_org_internal = res.data.id_org_internal;
                    this.providersService.getProviderDetailById(this.id_org_internal).subscribe(
                        (res) => {
                            if (res.success) {
                                this.provider = res.data as UserProvider;
                                this.url = res.data.logo;
                                this.blockUI.stop();
                            } else {
                                this.blockUI.stop();
                                if (res.errorSet.includes('ERROR_SERVER')) {
                                    this.toastrService.error('Une erreur serveur est survenue');
                                }
                            }
                        },
                        (error) => {
                            this.blockUI.stop();
                            // console.error(error);
                            this.toastrService.error('Une erreur s\'est produite');
                        }
                    );
                    this.blockUI.stop();
                } else {
                    this.blockUI.stop();
                    if (res.errorSet.includes('InvalidRequest')) {
                        this.toastrService.error('Les paramètres sont invalides');
                    } else if (res.errorSet.includes('TokenError')) {
                        this.toastrService.error('Token non trouvé ou invalidé');
                    }
                }
            },
            (error) => {
                this.blockUI.stop();
                // console.error(error);
                this.toastrService.error('Une erreur s\'est produite');
            }
        );
    }

    openAccountModification(): void {
        const modalRef = this.accountModalService.open(AccountModificationComponent);
        modalRef.componentInstance.id = this.id_user;
        modalRef.componentInstance.updateDataAccount.subscribe(($ev: { success: boolean, phone: string }) => {

            if ($ev.success) {
                this.provider.phone = $ev.phone;
            }
        });
    }

    openAccountModificationPassword(): void {
        const modalRef = this.accountModalService.open(AccountModificationPwdComponent);
        modalRef.componentInstance.id = this.id_user;
    }

    openDeleteAccount(): void {
        const modalRef = this.accountModalService.open(AccountDeletionComponent);
        modalRef.componentInstance.id = this.id_user;
    }
}
